import React from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { Button as BaseButton } from '~/prix/react/components/button'
import { PulseLoader } from 'react-spinners'
import theme from '~/design'
import { SizeProp } from '@fortawesome/fontawesome-svg-core'

const Button = styled(BaseButton)<{
  color?: string
  $backgroundColor?: string
  fontSize?: number
}>`
  display: flex;
  color: ${({ color, theme }) => color || theme.colors.lightText};
  background-color: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors.primary};
  gap: 10px;
  font-size: ${({ fontSize }) => fontSize || 16}px;
  svg {
    margin-right: 0;
  }
`

interface ButtonVariantsProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: IconDefinition
  label?: string
  size?: SizeProp
  color?: string
  backgroundColor?: string
  isLoading?: boolean
  variant?: 'primary' | 'secondary' | 'transparent' | 'light'
  children?: React.ReactNode
}

const textSize: Record<SizeProp, number> = {
  '2xs': 10,
  xs: 13,
  sm: 14,
  lg: 16,
  xl: 18,
  '2xl': 20,
  '1x': 22,
  '2x': 24,
  '3x': 26,
  '4x': 28,
  '5x': 32,
  '6x': 36,
  '7x': 40,
  '8x': 44,
  '9x': 48,
  '10x': 52,
}

export const ButtonVariants = ({
  icon,
  onClick,
  label,
  size = 'sm',
  variant,
  backgroundColor,
  isLoading,
  children,
  ...props
}: ButtonVariantsProps) => {
  switch (variant) {
    case 'primary':
      backgroundColor = theme.colors.primary
      props.color = theme.colors.lightText
      break
    case 'secondary':
      backgroundColor = theme.colors.secondary
      props.color = theme.colors.lightText
      break
    case 'transparent':
      backgroundColor = 'transparent'
      props.color = theme.colors.primary
      break
    case 'light':
      backgroundColor = theme.colors.lightText
      props.color = theme.colors.darkText
      break
  }

  return (
    <Button
      onClick={onClick}
      fontSize={textSize[size]}
      $backgroundColor={backgroundColor}
      {...props}
    >
      {isLoading && <PulseLoader color={props.color} size={textSize[size] / 2} />}
      {icon && <FontAwesomeIcon icon={icon} size={size} />}
      {label ? label : null}
      {children ? children : null}
    </Button>
  )
}
